"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconsWrapper = exports.FadeOutEffect = exports.CloseIconWrapper = exports.CloseIcon = exports.CheckmarkIconWrapper = exports.CheckmarkIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var iconWrapperBase = "\n  border: 1px solid #595858;\n  display: flex;\n  align-items: center;\n  height: 56px;\n  width: 56px;\n  padding: 3px;\n  border-radius: 3px;\n  margin: 3px 5px 3px 0;\n";
var CheckmarkIconWrapper = exports.CheckmarkIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__CheckmarkIconWrapper",
  componentId: "sc-1keu1h0-0"
})(["", " color:#595858;", ""], iconWrapperBase, function (_ref) {
  var size = _ref.size;
  return size === 'small' ? 'height: 30px; width: 30px;' : '';
});
var CloseIconWrapper = exports.CloseIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__CloseIconWrapper",
  componentId: "sc-1keu1h0-1"
})(["", " ", ""], iconWrapperBase, function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? 'height: 30px; width: 30px;' : '';
});
var IconsWrapper = exports.IconsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__IconsWrapper",
  componentId: "sc-1keu1h0-2"
})(["display:flex;postion:relative;justify-content:", ";margin:", ";"], function (_ref3) {
  var position = _ref3.position;
  return position === 'left' ? 'flex-start' : 'center';
}, function (_ref4) {
  var position = _ref4.position;
  return position === 'left' ? '0 0 0 0' : '0 0 15px 15px';
});
var CheckmarkIcon = exports.CheckmarkIcon = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "styles__CheckmarkIcon",
  componentId: "sc-1keu1h0-3"
})(["height:", ";margin:auto;"], function (_ref5) {
  var size = _ref5.size;
  return size === 'small' ? '15px' : '25px';
});
var CloseIcon = exports.CloseIcon = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "styles__CloseIcon",
  componentId: "sc-1keu1h0-4"
})(["height:", ";margin:auto;"], function (_ref6) {
  var size = _ref6.size;
  return size === 'small' ? '8px' : '12px';
});
var FadeOutEffect = exports.FadeOutEffect = _styledComponents["default"].div.withConfig({
  displayName: "styles__FadeOutEffect",
  componentId: "sc-1keu1h0-5"
})(["background:#fff;opacity:0.8;position:absolute;height:60px;width:125px;", ""], function (_ref7) {
  var size = _ref7.size;
  return size === 'small' ? 'height: 35px; width: 75px;' : '';
});
//# sourceMappingURL=styles.js.map